<script>
import NoRecordFound from '@/src/components/_norecord-found'

export default {
  components: {
    NoRecordFound,
  },
  props: {
    voterInformation: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    votersInformation() {
      return this.voterInformation
    },
  },
  methods: {
    formatDisplay(value) {
      return value || null
    },
  },
}
</script>

<template>
  <div>
    <div v-if="votersInformation.length">
      <div
        v-for="(item, index) in votersInformation"
        :key="index"
        :class="$style.relativesContainer"
        class="mx-1 border"
      >
        <b-row>
          <b-col :class="$style.label"
            ><strong>Name:</strong> {{ formatDisplay(item.name) }}</b-col
          >
          <b-col :class="$style.label"
            ><strong>Date of Birth:</strong>
            {{ formatDisplay(item.dateOfBirth) }}</b-col
          >
          <b-col :class="$style.label"
            ><strong>Registration Date:</strong>
            {{ formatDisplay(item.registrationDate) }}</b-col
          >
        </b-row>
        <b-row>
          <b-col :class="$style.label"
            ><strong>Gender:</strong> {{ formatDisplay(item.gender) }}</b-col
          >
          <b-col :class="$style.label"
            ><strong>Occupation:</strong> {{ formatDisplay(item.occupation) }}</b-col
          >
          <b-col :class="$style.label"
            ><strong>Last Vote Date:</strong>
            {{ formatDisplay(item.lastVoteDate) }}</b-col
          >
        </b-row>
        <b-row>
          <b-col cols="4" :class="$style.label"
            ><strong>Address:</strong> {{ formatDisplay(item.address) }}</b-col
          >
          <b-col cols="4" :class="$style.label"
            ><strong>Mailing Address:</strong>
            {{ formatDisplay(item.mailingAddress) }}</b-col
          >
        </b-row>
      </div>
    </div>
    <NoRecordFound v-else class="mx-1"></NoRecordFound>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.label {
  font-size: $size-content-font;
  color: $color-text-gray;
}
.relativesContainer {
  padding: 5px 15px;
  // font-size: 12px;
  // border: 1px solid #6d6e70;
}
.relativesContainer:nth-child(odd) {
  background: #fff;
}
.relativesContainer:nth-child(even) {
  background: #eee;
}
</style>
